<div class="make-responsive-entitylist-shadow w-100 d-grid uni-entitylist">
    <div class="grid-detials-area1-container">
        <div class="d-flex justify-space-between flex-column">
            <div
                [ngClass]="sharedService.rbacManagement('entities_Catalogue') ? 'align-items-center' : 'd-flex align-items-start ai-center'">
                <div class="d-flex space-between">
                    <div class="d-flex">
                        <div>
                            <div class="header-status" [ngStyle]="{background: entitiesStatus?.color}"
                                [matTooltip]="entitiesStatus?.status"></div>
                        </div>
                        <div *ngIf="entityDetails?.category === 'monotainer'" class="mono-Id">Monotainer ID</div>
                        <div>
                            <div class="vehicle-profile-header fontsize-value d-flex gap10">
                                <span class="text-black uni-text-black">{{entityDetails?.uniqueId}}</span> <span
                                    *ngIf="isCategoryShow"
                                    class="fontsize-value-categrory">{{entityDetails?.primaryDetails?.category}}</span>
                            </div>
                        </div>
                    </div>
            
                    <div *ngIf="sharedService.rbacManagement('entities_Catalogue')" class="catalogue-icon cursor">
                        <img src="../../../../assets/images/catalog.svg" alt="" matTooltip="Catalogue" (click)="goToCatalogue()">
                    </div>
                </div>
                <div class="disp-icons-wrapper" *ngIf="entityDetails?.type == 1">
                    <ul class="vehicle-warning-indicators flex1"
                        *ngIf="trlConfig?.tenant!=='TRL' && trlConfig?.tenant!=='VOT'">
                        <li *ngFor="let icon of iconsList"
                            class="d-flex flex-column justify-content-center align-items-center">
                            <span><img src="{{icon?.imgUrl + token}}" [alt]=icon?.altName [title]=icon?.value></span>
                        </li>
                    </ul>
                    <span *ngIf="trlConfig?.tenant==='TRL'">
                        <img src="../../../../assets/images/ignition-trl.svg" alt="" matTooltip="Ignition">
                        <img src="../../../../assets/images/acceleration-trl.svg" alt="acc"
                            matTooltip="Hard Acceleration">
                        <img src="../../../../assets/images/clutch-trl.svg" alt="clutch" matTooltip="Clutch Press">
                        <img src="../../../../assets/images/brake-press-trl.svg" alt="brake" matTooltip="Brake Press">
                        <!-- <img src="../../../../assets/images/indicators-trl.svg" alt="indicator"
                        matTooltip="Disabled Indicator"> -->
                    </span>
                </div>
                <div *ngIf="entityDetails?.secondaryDetails?.brandLogo" class="w-100 text-right">
                    <img src="{{entityDetails?.secondaryDetails?.brandLogo + token}}" alt="logo" class="h-20 img-fluid">
                </div>
            </div>
            <div class="d-flex mb-2"
                *ngIf="entityDetails?.category != 'patient' && entityDetails?.category != 'monotainer' && !isCategoryShow">
                <div class="vehicle-gen-dtls pt  flex1 flex-column">
                    <div class="d-flex" class="sub-details d-flex gap5 uni-sub-details">
                        <div *ngFor="let detailKey of primaryDetails" class="d-flex">
                            <div *ngIf="detailKey==='make'">
                                {{entityDetails?.primaryDetails[detailKey]}}&nbsp;{{entityDetails?.primaryDetails[detailKey]?'-':''}}
                            </div>
                            <div *ngIf="detailKey==='model'">
                                {{entityDetails?.primaryDetails[detailKey]}}&nbsp;{{entityDetails?.primaryDetails[detailKey]?'-':''}}
                            </div>
                            <div *ngIf="detailKey==='variant'">
                                {{entityDetails?.primaryDetails[detailKey]}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="chips-container">
                <div class="chips-container1"
                    *ngIf="entityDetails?.category != 'patient' && entityDetails?.category != 'monotainer' && !isCategoryShow">
                    <div class="validops-chips" *ngIf="entityDetails?.secondaryDetails?.engineModel" [matTooltip]="'Engine Model: ' + entityDetails?.secondaryDetails?.engineModel">
                        {{entityDetails?.secondaryDetails?.engineModel}}</div>
                    <div class="validops-chips" *ngIf="entityDetails?.secondaryDetails?.fuelType" [matTooltip]="'Fuel Type: ' + entityDetails?.secondaryDetails?.fuelType">
                        {{entityDetails?.secondaryDetails?.fuelType}}</div>
                    <div class="validops-chips" *ngIf="entityDetails?.secondaryDetails?.emissionNorm" [matTooltip]="'Emission Norm: ' + entityDetails?.secondaryDetails?.emissionNorm">
                        {{entityDetails?.secondaryDetails?.emissionNorm}}</div>
                    <div class="validops-chips" *ngIf="entityDetails?.category" [matTooltip]="'Category: ' + entityDetails?.category">
                        {{entityDetails?.category}}</div>
                    <div class="validops-chips" *ngIf="entityDetails?.secondaryDetails?.type" [matTooltip]="'Type: ' + entityDetails?.secondaryDetails?.type | titlecase">
                        {{entityDetails?.secondaryDetails?.type | titlecase}}</div>
                    <!-- <div class="validops-chips" *ngIf="ignitionStatus || ignitionStatus === 0" [matTooltip]="entityDetails?.secondaryDetails?.fuelType === 'EV' ? 'Power': 'Ignition Status'">
                        {{ignitionStatus === 1 ? 'ON' :
                        'OFF'}}</div> -->
                    <div class="validops-chips" [matTooltip]="'Operational Status: ' + getOperationalStatusName(listingDetails?.[0]?.operationalStatus)?.name | titlecase"
                        [style.background-color]="getOperationalStatusName(listingDetails?.[0]?.operationalStatus)?.selectedBgColor"
                        [style.color]="getOperationalStatusName(listingDetails?.[0]?.operationalStatus)?.textColor"
                        *ngIf="listingDetails?.[0]?.operationalStatus">
                        {{getOperationalStatusName(listingDetails?.[0]?.operationalStatus)?.name | titlecase}}
                    </div>
                </div>
                <div *ngIf="trlConfig?.tenant === 'VOT'" class="alert-icon-profile position-relative">
                    <div>
                        <div class="align-items-center gap10 margin-bottom">
                            <img src="../../../../assets/images/dtc_icon_mgm.svg" [matTooltip]="'Active DTC Cases: ' + dtcCasesCount"
                                *ngIf="dtcCasesCount" alt="DTC" class="cursor"/>
                            <img src="../../../../assets/images/dtc-icon-disabled.svg" [matTooltip]="'Active DTC Cases: ' + dtcCasesCount"
                                *ngIf="!dtcCasesCount" alt="DTC" class="bell-pointer"/>
                        </div>
                        <div class="align-items-center gap10">
                            <img [src]="activeAlertsCount ? '../../../../assets/images/alert_icon_mgm.svg' : '../../../../assets/images/alert-icon-disabled.svg'"
                                [matTooltip]="'Active Alerts:' + activeAlertsCount" alt="Alerts"
                                [ngClass]="!activeAlertsCount ? 'bell-pointer' : 'cursor'"/>
                        </div>
                    </div>
                </div>
            </div>
            <div class="d-flex mb-2"
                *ngIf="entityDetails?.category != 'patient' && entityDetails?.category != 'monotainer' && isCategoryShow">
                <div class="vehicle-gen-dtls pt flex1 flex-column">
                    <div class="detail-values">
                        <div>{{entityDetails?.name}}</div>
                        <div>{{entityDetails?.primaryDetails?.make}} - {{entityDetails?.primaryDetails?.model}}
                        </div>
                        <!-- <div>{{entityDetails?.primaryDetails?.model}}</div> -->
                    </div>
                </div>
            </div>
            <div class="vehicle-image position-relative h-100 w-100 cursor d-flex"
                *ngIf="entityDetails?.category != 'patient' && entityDetails?.category != 'sedan'">
                <img *ngIf="!image"
                    [src]="defaultImageVot ? defaultImageVot+token : (defaultImage ? defaultImage+token : service.getDefaultImageByCategory(entityDetails?.category))"
                    class="v-image" alt="vehicle">
                <img *ngIf="image" [src]="image" alt="vehicle" class="v-image"
                    [ngClass]="{'h-entity-image image-fluid':trlConfig?.tenant!=='TRL'}">
            </div>
            <div *ngIf="entityDetails?.type == 3 && entityDetails?.category == 'patient'" class="cursor">
                <div class="position-relative"><img src="../../../../assets/images/human-body.png"
                        class="img-fluid mw-350" alt="human">
                    <div class="vital-point-pointer vital-point-pointer-blue"></div>
                    <div class="vital-point-pointer vital-point-pointer-green"></div>
                    <div class="vital-point-pointer vital-point-pointer-yellow"></div>
                </div>
            </div>
            <div *ngIf="entityDetails?.type == 1 && entityDetails?.category == 'sedan'" class="cursor">
                <div class="position-relative"><img src="../../../../assets/images/vehicle-blueprint.png"
                        class="img-fluid mw-350" alt="sedan">
                    <div class="vital-point-pointer vital-point-pointer-one"></div>
                    <div class="vital-point-pointer vital-point-pointer-two"></div>
                    <div class="vital-point-pointer vital-point-pointer-three"></div>
                    <div class="vital-point-pointer vital-point-pointer-four"></div>
                </div>
            </div>
        </div>
        <!-- <div class="d-flex" *ngIf="entityDetails?.category != 'patient' && entityDetails?.category != 'monotainer'">
        <div class="vehicle-gen-dtls pt flex1">
            <div *ngFor="let detail of primaryDetails">
                <div>{{detail}}</div>
            </div>
        </div>
        <div class="doc-box" *ngIf="entityDetails?.documents">
            <div class="doc-header">Documents</div>
            <div class="docs-detail">
                <ul class="vehicle-warning-indicators" *ngFor="let doc of entityDetails?.documents">
                    <li class="d-flex flex-column justify-content-center align-items-center"><span><a [href]="doc?.url"
                                target="_blank" class="ml-auto"><img src="../../assets/images/arcticons_documents.svg"
                                    class="h-30 cursor " alt="file" [title]="doc?.name"></a></span>
                        <span>{{doc?.name | truncate:3}}</span>
                    </li>

                </ul>
            </div>
        </div>
    </div> -->
        <div class="action-wrapper">
            <div class="digital-twin-wrapper" *ngIf="sharedService.rbacManagement('entities_DigitalTwin')">
                <span class="digital-twin cursor" (click)="navigateTo()">
                    <span>
                        <img src="../../assets/images/digital-twin-car.svg" alt="digital-twin">&nbsp;&nbsp;
                    </span>Digital Twin
                </span>
            </div>
            <div class="digital-twin-wrapper" *ngIf="sharedService.rbacManagement('entities_DigitalTwin')">
                <span class="digital-twin cursor" (click)="openMappingDetails()" matTooltip="Profile Configuration">
                    <span>
                        <img src="../../assets/images/idec-settings-white.svg" class="h-20" alt="mapping">
                    </span>
                </span>
            </div>
        </div>
        <div class="d-flex align-self justify-space-between pe-2">
            <div *ngIf="trlConfig?.profileDetailsFooterTileAttributes"
                class="d-flex align-items-basline w-100 gap10 mt-2">
                <!-- <div class="validops-footer uni-profile-footer"
                    *ngFor="let attribute of trlConfig?.profileDetailsFooterTileAttributes">
                    <div class="validops-value uni-profile-value" [title]="aggrDetails?.[0]?.[attribute?.name] ?? 0">
                        {{ aggrDetails?.[0]?.[attribute?.name] ? (aggrDetails?.[0]?.[attribute?.name])?.toFixed(1) : 0}}
                        {{ attribute?.uom }}
                    </div>
                    <div class="validops-value-footer uni-profile-value-footer d-flex">
                        <div>{{ attribute?.attributeName }}</div>
                    </div>
                </div> -->
                <div class="validops-footer uni-profile-footer"
                    *ngFor="let attribute of trlConfig?.profileDetailsFooterTileAttributes">
                    <div class="validops-value uni-profile-value" [title]="summary?.[attribute?.name] ?? 0">
                        {{ summary?.[attribute?.name] ? (summary?.[attribute?.name])?.toFixed(2) : 0}}
                        {{ attribute?.uom }}
                    </div>
                    <div class="validops-value-footer uni-profile-value-footer d-flex">
                        <div>{{ attribute?.attributeName }}</div>
                    </div>
                </div>
                <div class="validops-footer uni-profile-footer">
                    <div class="validops-value uni-profile-value" [title]="rpm ?? 0">
                        {{rpm ? (rpm)?.toFixed(2) : 0}}
                    </div>
                    <div class="validops-value-footer uni-profile-value-footer d-flex">
                        <div>RPM</div>
                    </div>
                </div>
            </div>
            <div class="doc-box ml-20" *ngIf="sharedService.rbacManagement('entities_Documents')">
                <div class="doc-header">Documents</div>
                <div class="docs-detail">
                    <div class="d-flex">
                        <ul class="vehicle-warning-indicators" *ngFor="let doc of entityDetails?.documents">
                            <li class="d-flex flex-column justify-content-center align-items-center"><span><a
                                        [href]="doc?.url" target="_blank" class="ml-auto"><img
                                            src="../../assets/images/documents-idec.svg" class="doc-img-size cursor"
                                            alt="file" [matTooltip]="doc?.name"></a></span>
                                <span>{{doc?.name | truncate:5}}</span>
                            </li>
                        </ul>
                    </div>
                    <div class="disabled">
                        <img src="../../assets/images/upload-idec.svg" alt="upload" matTooltip="Upload">
                    </div>
                </div>
            </div>
            <div class="thumbnail" *ngIf="entityDetails?.dtsc?.thumbnailUrl" (click)="popRouteClick()"
                matTooltip="Last Updated {{entityDetails?.dtsc?.updatedDate | date:'medium'}}">
                <div class="doc-header nowrap mb-2">Checkpoint Reference</div>
                <img src="{{entityDetails?.dtsc?.thumbnailUrl+'&'+timeStamp}}" alt="Thumbnail" class="w-100 brand-logo">
            </div>
            <div *ngIf="popRoute cursor" class="expand pop-style">
                <div class="pop-close">
                    <span class="pop-label cursor" (click)="popRouteClick()">Close</span>
                </div>
                <img src="{{entityDetails?.dtsc?.imageUrl+'&'+timeStamp}}" alt="snapshot" class="image-fluid">
            </div>
            <div class="digital-twin-wrapper" (click)="onNavigateToPlanClick()" [matTooltip]="'Find in FloorPlan'"
                *ngIf="floorplanRedirect && sharedService.rbacManagement('entities_LocateInFloorPlan')">
                <span class="digital-twin cursor">
                    <span>
                        <img src="../../assets/images/white_marker.svg" class="h-20" alt="mapping">
                    </span>
                </span>
            </div>
        </div>
    </div>